import { connect } from 'react-redux';
import { getInputDataToSend, getCornerPosts } from '../../../../store/form/selectors';
import { fetchProductsData } from '../../../../store/products/actions';
import { fetchProductsBySection, setInputDataToSend } from '../../../../store/form/actions';
import CornerPostSection from './CornerPostSection';
import { getValidation } from '../../../../store/validation/selectors';

const mapStateToProps = (state) => ({
  cornerPosts: getCornerPosts(state),
  inputData: getInputDataToSend(state),
  validation: getValidation(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchProductsData: () => dispatch(fetchProductsData()),
  fetchProductsBySection: (
    section,
    panelGroup,
    postGroup,
    accessoryGroup,
    color,
    type,
    height,
    isCorner,
    cornerPostGroup,
  ) => {
    dispatch(fetchProductsBySection(
      section,
      panelGroup,
      postGroup,
      accessoryGroup,
      color,
      type,
      height,
      isCorner,
      cornerPostGroup,
    ));
  },
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CornerPostSection);
